import {uniq} from 'lodash';
import {BidListState} from "../../interfaces/bid-list.interface";

export const enum BidListActions {
  SET_STATE = 'SET_STATE',
  TOGGLE_VEHICLE = 'TOGGLE_VEHICLE',
  TOGGLE_ALL_VEHICLES = 'TOGGLE_ALL_VEHICLES',
  UNTOGGLE_ALL_VEHICLES = 'UNTOGGLE_ALL_VEHICLES',
}

export type BidListAction =
  | ToggleVehicle
  | ToggleAllVehicles
  | UnToggleAllVehicles
  | SetState;

export type Selector<T> = (state: BidListState) => T;

export class ToggleVehicle {
  readonly type = BidListActions.TOGGLE_VEHICLE;
  constructor(readonly vehicle: string) {
  }
}

export class ToggleAllVehicles {
  readonly type = BidListActions.TOGGLE_ALL_VEHICLES;
  constructor(readonly vehicles: string[]) {
  }
}

export class UnToggleAllVehicles {
  readonly type = BidListActions.UNTOGGLE_ALL_VEHICLES;
  constructor(readonly vehicles: string[]) {
  }
}

export class SetState {
  readonly type = BidListActions.SET_STATE;
  constructor(readonly state: BidListState) {
  }
}

export function selectedHasVehicles(state: BidListState): boolean {
  return state.selectedVehicles.length > 0;
}

export function selectedVehiclesCount(state: BidListState): number {
  return state.selectedVehicles.length;
}

export function selectedVehicles(state: BidListState): string[] {
  return state.selectedVehicles;
}

export function bidListReducer(state: BidListState, action: BidListAction): BidListState {
  switch (action.type) {
  case BidListActions.SET_STATE: {
    return {...action.state};
  }
  case BidListActions.TOGGLE_VEHICLE: {
    const selectedVehicleState = selectedVehicles(state);
    const index = selectedVehicleState.findIndex(e => e === action.vehicle);

    if (index === -1) {
      addVehicle(action.vehicle, state);
    } else {
      removeVehicle(index, state);
    }

    return {
      ...state,
      selectedVehicles: state.selectedVehicles,
      selectAll: false
    };
  }
  case BidListActions.TOGGLE_ALL_VEHICLES: {
    const selectedVehicleState = selectedVehicles(state);
    return {
      ...state,
      selectedVehicles: uniq(selectedVehicleState.concat(action.vehicles)),
      selectAll: true
    };
  }
  case BidListActions.UNTOGGLE_ALL_VEHICLES: {
    let selectedVehicleState = selectedVehicles(state);
    const vehiclesToToggle = action.vehicles;

    selectedVehicleState = selectedVehicleState.filter(sv => !vehiclesToToggle.map(vtt => vtt).includes(sv));

    return {
      ...state,
      selectedVehicles: selectedVehicleState,
      selectAll: false
    };
  }
  default: {
    return state;
  }
  }
}

function removeVehicle(index: number, state: BidListState) {
  state.selectedVehicles.splice(index, 1);
}

function addVehicle(uuid: string, state: BidListState) {
  state.selectedVehicles.push(uuid);
}
